import Flickity from "flickity";
require('flickity-fade');

export default function () {

  const clientsCarousels = document.querySelectorAll('[data-testimonial-slider]');

  if(clientsCarousels) {
    clientsCarousels.forEach(function (elem, index) {
      if (elem) {
        // Define carousel options
        let carouselOptions = {
          prevNextButtons: false,
          draggable: false,
          autoPlay: 4000,
          fade: true,
        };


        new Flickity(elem, carouselOptions);
      }
    });
  }
}
